/**
 * Channel management tools on screens (settings sheet from the header, join bar, archived notice). The app turns them
 * on with its feature flag; off, channel screens look and behave as before.
 */
import { createContext, useContext } from "react";

export const ChannelToolsContext = createContext(false);

export function useChannelTools(): boolean {
  return useContext(ChannelToolsContext);
}
